// auth-guard.ts
import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

import { UserService } from './user.service';
import * as _ from 'lodash';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private _user: UserService, private _router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    var redirect = _.map(next.url, p => {
      return p.path;
    });

    if (redirect.length == 0) {
      redirect.push('');
    }

    var qp = {
      redirect: JSON.stringify(redirect)
    };

    ['status', 'room', 'owner', 'tabindex', 'pid'].forEach(x => {
      if (next.queryParamMap.has(x)) {
        qp[x] = next.queryParams[x];
      }
    });

    if (!this._user.isLoggedIn()) {
      this._router.navigate(['login'], {
        queryParams: qp
      });
    } else {
      return true;
    }
  }
}

export const AUTH_GUARD_PROVIDERS = [AuthGuard];
